const LocalStorage = require('./localStorage');
const CookieStorage = require('./cookieStorage');
const AsyncStorage = require('./asyncStorage');
const Logger = require('../utils/logger');

function Storage(options) {
  this.log = new Logger();
  this.storage = new CookieStorage(options);

  // Use local storage for web, async storage for react-native, otherwise fallback to cookie storage
  try {
    if (typeof document !== 'undefined') {
      // # web environment
      var localStorage = new LocalStorage();
      this.storage = localStorage;
    } else if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
      // # react-native environment
      this.log.warn('using React-Native async storage.');
      var asyncStorage = new AsyncStorage();
      this.storage = asyncStorage;
    }
  } catch (e) {
    this.log.warn(e);
    this.log.warn('LocalStorage is not available. Using cookies instead.');
  }
}

Storage.prototype.getItem = function(key) {
  const value = this.storage.getItem(key);
  try {
    return JSON.parse(value);
  } catch (e) {
    return value;
  }
};

Storage.prototype.setItem = function(key, val) {
  const json = JSON.stringify(val);
  return this.storage.setItem(key, json);
};

Storage.prototype.removeItem = function(key) {
  return this.storage.removeItem(key);
};

module.exports = Storage;
